export default {
  featuredImage: {
    description: "Chuck Data",
    height: 700,
    url: "/img/ChuckData_Hero.jpg",
    width: 1080
  },
  codeSnippet: "pip install chuck-data",
  githubLink: "https://github.com/amperity/chuck-data",
  chuckMascot: {
    src: "/img/Chuck_Mascot.svg",
    title: "Chuck, a pixelated teal woodchuck with sunglasses"
  },
  chuckVideoThumbnail: {
    src: "https://images.ctfassets.net/5vqt5w81x2im/6WByDhTACmEYq4gFvWul7c/e86db1e0195874c68fbb42f5a3d553e8/Demo_ChuckData_LPThumbnail.png",
    alt: "Chuck Demo",
    width: 800,
    height: 450
  },
  featuresData: [
    {
      title: "Profile your customer data",
      description:
        "Scan your Unity Catalog, summarize relevant tables, and identify the appropriate data for your use case."
    },
    {
      title: "PII data standardization",
      description:
        "Apply semantic tagging and sophisticated data standardization across your customer data tables—no schema required."
    },
    {
      title: "Customer identity resolution",
      description:
        "Apply Amperity’s multi-patented Identity Resolution algorithms to create a first-party identity graph."
    },
    {
      title: "Power compliance workflows",
      description:
        "Automatically identify, classify, and tag PII—ensuring nothing slips through the cracks."
    }
  ],
  quote: {
    quote:
      '"A lot of organizations find that when building the 360 view, connecting customers across data sources is where it becomes very difficult. Amperity has built a solution that is capable of managing this space."',
    attribution: "Bryan Smith\nTechnical Director for Retail & CPG, \nDatabricks",
    styling: "h3",
    backgroundColor: "midnight",
    logo: {
      alt: "Databricks logo",
      height: 50,
      src: "https://images.ctfassets.net/5vqt5w81x2im/2SjI58eEjtia78zh7w1Mj5/d28e234c40956667fe0efcbc38b360f4/Databricks_logo.svg",
      width: 150
    }
  },
  benefits: [
    {
      header: "Works in your terminal, on your terms",
      description:
        "Chuck is built natively in your terminal using your LLM of choice and Unity Catalog to build and manage customer data models in Databricks."
    },
    {
      header: "Complete days of coding with a single prompt",
      description:
        "Chuck transforms customer data engineering with natural language commands and AI that understands your data so you can execute tedious tasks in minutes. "
    },
    {
      header: "Built-in customer data domain expertise",
      description:
        "Chuck uses Amperity's years of experience and patented Identity Resolution models, trained on billions of datasets across 400+ enterprise brands, as critical knowledge behind the AI."
    }
  ]
}
